module.exports = __webpack_public_path__ + "img/laboratorio2_9-16_1080.56b96472.jpg";